<ion-card
  class="import-error-toast"
  [class.mobile]="platform === platformRef.mobile"
>
  <ion-row>
    <ion-col
      [size]="platform !== platformRef.mobile ? 0.5 : 1"
      class="align-left"
      [class.mobile]="platform === platformRef.mobile"
      ><ion-icon name="alert-circle-outline"></ion-icon
    ></ion-col>
    <ion-col
      *ngIf="platform !== platformRef.mobile"
      [size]="platform === platformRef.desktop ? 4 : 5"
      class="align-center"
      ><ion-label class="error-one" data-cy="import-list-error-toast-one">{{
        'i18n.lists.importListModal.message.errorInLine1' | translate
      }}</ion-label></ion-col
    >
    <ion-col
      *ngIf="platform !== platformRef.mobile"
      [size]="platform === platformRef.desktop ? 2 : 4.5"
      [offset]="platform === platformRef.desktop ? 5 : 1.5"
      class="align-center"
      [class.force-shift-right]="platform === platformRef.tablet"
    >
      <ion-label
        (click)="openModal()"
        class="error-two"
        data-cy="import-list-error-toast-two"
        >{{
          'i18n.lists.importListModal.message.errorInLine2' | translate
        }}</ion-label
      ></ion-col
    >
    <ion-col
      *ngIf="platform === platformRef.mobile"
      offset="0.5"
      class="center-mobile"
      size="9"
    >
      <div>
        <ion-label class="error-one" data-cy="import-list-error-toast-one"
          >{{ 'i18n.lists.importListModal.message.errorInMobile1' | translate
          }}<br />{{
            'i18n.lists.importListModal.message.errorInMobile2' | translate
          }}</ion-label
        >
      </div>
      <div>
        <ion-label
          (click)="openModal()"
          class="error-two"
          data-cy="import-list-error-toast-two"
          >{{
            'i18n.lists.importListModal.message.errorInLine2' | translate
          }}</ion-label
        >
      </div>
    </ion-col>
    <ion-col
      [size]="platform !== platformRef.mobile ? 0.5 : 1"
      class="align-right"
      [offset]="platform === platformRef.mobile ? 0.5 : 0"
      [class.mobile]="platform === platformRef.mobile"
      ><ion-icon
        name="close-circle"
        class="close"
        (click)="dismissToast()"
      ></ion-icon
    ></ion-col>
  </ion-row>
</ion-card>
